// Dependencies
import axios from 'axios';
import { API_URL, X_API_KEY, X_API_VERSION } from '../conf.js';
import { getCookie } from '../shared/utils/cookies';
import { axiosInterceptors } from '../shared/utils/axiosInterceptors';
import { objectToFormData } from 'object-to-formdata';

// Action Types
import {
  GET_COUPON_REQUEST,
  GET_COUPON_SUCCESS,
  GET_COUPON_ERROR,
  GET_COUPONS_REQUEST,
  GET_COUPONS_SUCCESS,
  GET_COUPONS_ERROR,
  ADD_COUPON_REQUEST,
  ADD_COUPON_SUCCESS,
  ADD_COUPON_ERROR,
  DELETE_COUPON_REQUEST,
  DELETE_COUPON_SUCCESS,
  DELETE_COUPON_ERROR,
  UPDATE_COUPON_REQUEST,
  UPDATE_COUPON_SUCCESS,
  UPDATE_COUPON_ERROR
} from './actionTypes';

// Base Actions
import { request, received, error } from '../shared/redux/baseActions';

const options = {
  /**
   * include array indices in FormData keys
   * defaults to false
   */
  indices: false,

  /**
   * treat null values like undefined values and ignore them
   * defaults to false
   */
  nullsAsUndefineds: false,

  /**
   * convert true or false to 1 or 0 respectively
   * defaults to false
   */
  booleansAsIntegers: false,
};

const getCoupon = (params) => dispatch => {
  dispatch(request(GET_COUPON_REQUEST));
  var id = '';
  if (typeof (params) !== 'undefined') {
    id = params;
  }
  // Axios Data
  const axiosData = {
    method: 'GET',
    url: API_URL + '/coupons/' + id,
    headers: {
      //Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Api-Key': X_API_KEY,
      'X-Api-Version': X_API_VERSION,
      'Authorization': 'Bearer ' + getCookie("_str")
    }
  };
  const axiosInstance = axios.create();
  axiosInterceptors(axiosInstance);
  return axiosInstance(axiosData)
    .then(response => dispatch(received(GET_COUPON_SUCCESS, response.data)))
    .catch(err => {
      // eslint-disable-next-line no-console
      console.log('AXIOS ERROR:', err.response);
      dispatch(error(GET_COUPON_ERROR));
    });
};

const getCoupons = (params) => dispatch => {
  dispatch(request(GET_COUPONS_REQUEST));
  var perPage = 10;
  var page = 1;
  console.log('GET_COUPONS');
  console.log(params);
  var url = API_URL + '/coupons?';
  var queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&');
  console.log(queryString);
  url += queryString;
  // Axios Data
  const axiosData = {
    method: 'GET',
    url: url,
    headers: {
      //Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Api-Key': X_API_KEY,
      'X-Api-Version': X_API_VERSION,
      'Authorization': 'Bearer ' + getCookie("_str")
    }
  };
  const axiosInstance = axios.create();
  axiosInterceptors(axiosInstance);
  return axiosInstance(axiosData)
    .then(response => dispatch(received(GET_COUPONS_SUCCESS, { items: response.data['items'], meta: response.data["meta"] })))
    .catch(err => {
      // eslint-disable-next-line no-console
      console.log('AXIOS ERROR:', err.response);
      dispatch(error(GET_COUPONS_ERROR));
    });
};

const addCoupon = (params) => dispatch => {
  dispatch(request(ADD_COUPON_REQUEST));
  var id = '';
  if (typeof (params) !== 'undefined') {
    id = params;
  }
  console.log('ADD_COUPON');
  console.log(params);
  params.address_attributes = params.address
  params.contact_attributes = params.contact
  params = { ...params, ...{ online: params.onlineStatus === 'online' } }
  console.log(params);

  // Axios Data
  const axiosData = {
    method: 'POST',
    url: API_URL + '/coupons',
    headers: {
      //Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
      'X-Api-Key': X_API_KEY,
      'X-Api-Version': X_API_VERSION,
      'Authorization': 'Bearer ' + getCookie("_str")
    },
    data: formData(params)
  };
  const axiosInstance = axios.create();
  axiosInterceptors(axiosInstance);
  return axiosInstance(axiosData)
    .then(response => dispatch(received(ADD_COUPON_SUCCESS, response.data['form'])))
    .catch(err => {
      // eslint-disable-next-line no-console
      console.log('AXIOS ERROR:', err.response);
      dispatch(error(ADD_COUPON_ERROR, err.response));
    });
};

const updateCoupon = (params) => dispatch => {
  dispatch(request(UPDATE_COUPON_REQUEST));
  var id = '';
  if (typeof (params) !== 'undefined') {
    id = params;
  }
  console.log('UPDATE_COUPON');
  params = { ...params, ...{ address_attributes: params.address } }
  params = { ...params, ...{ contact_attributes: params.contact } }
  if (params.onlineStatus) {
    params = { ...params, ...{ online: params.onlineStatus === 'online' } }
  }
  console.log(params);
  // Axios Data
  const axiosData = {
    method: 'PATCH',
    url: API_URL + '/coupons/' + params.id,
    headers: {
      //Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
      'X-Api-Key': X_API_KEY,
      'X-Api-Version': X_API_VERSION,
      'Authorization': 'Bearer ' + getCookie("_str")
    },
    data: formData(params)
  };
  const axiosInstance = axios.create();
  axiosInterceptors(axiosInstance);
  return axiosInstance(axiosData)
    .then(response => dispatch(received(UPDATE_COUPON_SUCCESS, response.data['form'])))
    .catch(err => {
      // eslint-disable-next-line no-console
      console.log('AXIOS ERROR:', err.response);
      dispatch(error(UPDATE_COUPON_ERROR, err.response));
    });
};

const deleteCoupon = (id) => dispatch => {
  dispatch(request(DELETE_COUPON_REQUEST));
  // Axios Data
  const axiosData = {
    method: 'DELETE',
    url: API_URL + '/coupons/' + id,
    headers: {
      //Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Api-Key': X_API_KEY,
      'X-Api-Version': X_API_VERSION,
      'Authorization': 'Bearer ' + getCookie("_str")
    }
  };
  const axiosInstance = axios.create();
  axiosInterceptors(axiosInstance);
  return axiosInstance(axiosData)
    .then(response => dispatch(received(DELETE_COUPON_SUCCESS, response.data)))
    .catch(err => {
      // eslint-disable-next-line no-console
      console.log('AXIOS ERROR:', err.response);
      dispatch(error(DELETE_COUPON_ERROR, err.response));
    });
};


const resetCoupon = () => dispatch => {
  dispatch(received(ADD_COUPON_SUCCESS, []))
};

function formData(params) {
  if (params.logo != null && typeof (params.logo) === 'object') {
    params.logo = params.logo[0];
  } else if (params.logo !== null) {
    delete params.logo;
  }
  if (params.logo_2x != null && typeof (params.logo_2x) === 'object') {
    params.logo_2x = params.logo_2x[0];
  } else if (params.logo_2x !== null) {
    delete params.logo_2x;
  }
  const formData = objectToFormData(
    params,
    options, // optional
    //existingFormData, // optional
    //keyPrefix, // optional
  );
  return formData;
}


export { getCoupon, getCoupons, addCoupon, updateCoupon, resetCoupon, deleteCoupon };
